<template>
  <!--  评价人审核 -->
  <div class="jxAppraiserReview">
    <van-nav-bar :title="$t('jxAppraiserReview.revTxt1')"
                 left-text
                 left-arrow
                 @click-left="onClickLeft" />
    <div class="overflow_div">
      <van-pull-refresh v-model="isLoadingAwait"
                        :success-text="$t('module.refreshSuccessfully')"
                        @refresh="onRefreshAwait">
        <van-list v-model="loadingAwait"
                  ref="appraisersList"
                  :finished="finishedAwait"
                  :finished-text="$t('module.noMore')"
                  @load="onLoadAwait">
          <van-collapse class="program_collapse"
                        v-model="programName"
                        accordion>
            <van-collapse-item class="program_collapse_item"
                               v-for="(el, id) in appraisersList"
                               :key="id"
                               :title="el.khplanname"
                               :name="id + 1">
              <van-collapse v-model="activeNames"
                            class="children_collapse">
                <van-collapse-item v-for="(item, index) in el.children"
                                   :key="index"
                                   :title="item.levelName"
                                   :name="index + 1"
                                   :value="item.pjper">
                  <div v-for="(it, idx) in item.levelArray.filter( le => le.empcode != null )"
                       :key="idx">
                    <van-cell @click="handleModelSelect(!it.modelSelect,appraisersList,it.autoid)"
                              class="ass_cell"
                              center
                              :title="it.empname"
                              :value="it.deptname"
                              :label="it.empcode">
                      <template #icon>
                        <van-checkbox v-if="sure_type != 1"
                                      v-model="it.modelSelect"
                                      style="margin-right: 10px;"></van-checkbox>
                        <img :src="it.picurl"
                             alt />
                      </template>
                    </van-cell>
                    <van-cell v-if="sure_type == 1"
                              class="batch_submission_cell">
                      <van-radio-group v-model="it.agree"
                                       direction="horizontal">
                        <van-radio :name="true">{{$t('jxAppraiserReview.revTxt3')}}</van-radio>
                        <van-radio :name="false">{{$t('jxAppraiserReview.revTxt2')}}</van-radio>
                      </van-radio-group>
                    </van-cell>
                  </div>
                </van-collapse-item>
              </van-collapse>
            </van-collapse-item>
          </van-collapse>
        </van-list>
      </van-pull-refresh>
    </div>
    <!-- <div class="entry_button">
      <span class="disagree"
            @click="disagreeEntry">不同意</span>
      <span @click="agreeEntry">同意</span>
    </div>-->
    <van-dialog v-model="showDisagree"
                :title="$t('jxAppraiserReview.revTxt4')"
                show-cancel-button
                confirmButtonColor="#2B8DF0"
                @confirm="confirm"
                @close="closeDia">
      <van-field v-model="disagreeReason"
                 name="disagreeReason"
                 rows="8"
                 class="disagreeReason"
                 autosize
                 type="textarea"
                 :placeholder="$t('jxAppraiserReview.revTxt5')"
                 show-word-limit />
    </van-dialog>
    <div class="divIsZW"></div>
    <!-- 按钮事件 limitDisabled-->
    <div class="buttonIsFixed"
         :class="'buttonIs_save'"
         :style="sure_type == 1?'justify-content: center;':''">
      <div v-if="sure_type == 1"
           style="width:100%;display:flex"
           :style="jump_btn_caption?'justify-content: space-between;':'justify-content: center;'">
        <van-button v-if="jump_btn_caption"
                    type="info"
                    style="width:48%"
                    @click="jumpSomeLink">{{jump_btn_caption}}</van-button>
        <van-button type="primary"
                    :style="{width:jump_btn_caption?'48%':'80%'}"
                    @click="submitOtherType">{{$t('module.submit')}}</van-button>
      </div>
      <div v-else
           style="display:flex">
        <van-button type="info"
                    @click="qxEvent">{{ selectText }}</van-button>
        <van-button type="warning"
                    style="margin-left: 10px;"
                    @click="btyEvent">不同意</van-button>
        <van-button type="primary"
                    style="margin-left: 10px;"
                    @click="tyEvent">同意</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant'
import {
  getUser360PjrList,
  agreeUser360Pjr,
  notAgreeUser360Pjr,
  batchAgreeUser360PjrList
} from '@/api/wxjx.js'
import { checkPic } from '@/utils'
export default {
  data () {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    return {
      userInfo,
      programName: 1,
      activeNames: [1, 2, 3],
      isLoadingAwait: false,
      loadingAwait: false,
      finishedAwait: false,
      appraisersList: [],
      showDisagree: false,
      disagreeReason: '', // 不同意原因
      programAutoid: 0, // 方案autoid
      use_dynamic_pjr: false, // 使用动态评价
      selectText: "全选",
      sure_jump_caption: '',
      sure_post_caption: '',
      sure_type: null,
      jump_btn_caption: ''
    }
  },
  mounted () {
    this.$refs.appraisersList.check()
  },
  methods: {
    jumpSomeLink () {
      //360待评价记录
      this.$router.push('/jxWhenMyAssesList')
    },
    // sure_type = 1 的时候全部提交
    submitOtherType () {
      // console.log(this.appraisersList, 'this.appraisersList')
      let subData = []
      for (let a = 0; a < this.appraisersList.length; a++)
      {
        const al = this.appraisersList[a];
        if (al.children.length > 0)
        {
          for (let b = 0; b < al.children.length; b++)
          {
            const bl = al.children[b];
            if (bl.levelArray.length > 0)
            {
              for (let c = 0; c < bl.levelArray.length; c++)
              {
                const cl = bl.levelArray[c];
                // 看看有没有全部选择
                if (cl.agree != true && cl.agree != false)
                {
                  Toast.fail('请全部评价完再提交！')
                  return false
                }
                const obj = {
                  autoid: cl.autoid,
                  agree: cl.agree
                }
                subData.push(obj)
              }
            }
          }
        }
      }
      // console.log(subData, 'subDatasubDatasubData');
      if (subData.length == 0)
      {
        Toast.fail(this.$t('module.PleaseAddRecBeforeSub'))
        return false
      }
      if (this.sure_post_caption)
      {
        Dialog.confirm({
          title: this.$t('module.systemhint'),
          message: this.sure_post_caption,
          confirmButtonText: this.$t('module.confirm'),
          cancelButtonText: this.$t('module.cancel')
        }).then(() => {
          this.batchAgreeUser360PjrFunc(subData)
        }).catch(() => { })
      } else
      {
        this.batchAgreeUser360PjrFunc(subData)
      }
    },
    // 批量接口
    batchAgreeUser360PjrFunc (subData) {
      batchAgreeUser360PjrList({
        username: this.userInfo.username,
        data: subData
      }).then(res => {
        if (res.data[0] && res.data[0].info)
        {
          Toast.fail(res.data[0].info)
        } else
        {
          Toast({
            message: this.$t('module.submitScu'),
            position: 'top'
          })
          this.onLoadAwait()
          // 如果revTxt13有设置就询问，没有就直接去360评价
          if (this.sure_jump_caption)
          {
            Dialog.confirm({
              title: this.$t('module.systemhint'),
              message: this.sure_jump_caption,
              confirmButtonText: this.$t('module.confirm'),
              cancelButtonText: this.$t('module.cancel')
            }).then(() => {
              //360待评价记录
              this.$router.push('/jxWhenMyAssesList')
            }).catch(() => { })
          } else
          {
            //360待评价记录
            this.$router.push('/jxWhenMyAssesList')
          }
        }
      })
    },
    // 回退
    onClickLeft () {
      this.$router.push('/home')
    },
    qxEvent () {
      if (this.selectText == "全选")
      {
        this.handleModelSelect('selectAll', this.appraisersList)
        this.selectText = "反选"
        // console.log(this.appraisersList, 'this.appraisersList')
      } else
      {
        this.handleModelSelect('invert', this.appraisersList)
        this.selectText = "全选"
      }
    },
    /**
     * 处理评价人选择状态的函数（直接修改原数据）
     * @param {'selectAll' | 'unselectAll' | 'invert'} operation - 操作类型
     * @param {Array} data - 要处理的数据（会直接修改）
     */
    handleModelSelect (operation, data, autoid) {
      // 处理全选操作
      if (operation === 'selectAll')
      {
        data.forEach(item => {
          item.children?.forEach(child => {
            child.levelArray?.forEach(levelItem => {
              levelItem.modelSelect = true;
            });
          });
        });
        return;
      }
      // 处理取消全选操作
      if (operation === 'unselectAll')
      {
        data.forEach(item => {
          item.children?.forEach(child => {
            child.levelArray?.forEach(levelItem => {
              levelItem.modelSelect = false;
            });
          });
        });
        return;
      }
      // 处理反选操作
      if (operation === 'invert')
      {
        data.forEach(item => {
          item.children?.forEach(child => {
            child.levelArray?.forEach(levelItem => {
              levelItem.modelSelect = !levelItem.modelSelect;
            });
          });
        });
        return;
      }
      if (typeof operation === 'boolean')
      {
        const autoidArray = Array.isArray(autoid) ? autoid : [autoid];

        data.forEach(item => {
          item.children?.forEach(child => {
            child.levelArray?.forEach(levelItem => {
              if (autoidArray.includes(levelItem.autoid))
              {
                levelItem.modelSelect = operation;
              }
            });
          });
        });
      }
    },
    /**
     * 筛选出所有 modelSelect 为 true 的项的 autoid
     * @param {Array} data - 原始数据
     * @returns {number[]} - 所有 modelSelect 为 true 的项的 autoid 数组
     */
    getSelectedAutoids (data) {
      const selectedAutoids = [];

      // 遍历数据
      data.forEach(item => {
        if (item.children && Array.isArray(item.children))
        {
          item.children.forEach(child => {
            if (child.levelArray && Array.isArray(child.levelArray))
            {
              child.levelArray.forEach(levelItem => {
                if (levelItem.modelSelect === true)
                {
                  selectedAutoids.push(levelItem.autoid);
                }
              });
            }
          });
        }
      });

      return selectedAutoids;
    },
    /**
     * 检查是否存在至少一项 modelSelect 为 true
     * @param {Array} data - 原始数据
     * @returns {boolean} - 存在选中项返回 true，否则返回 false
   */
    hasAnySelected (data) {
      return data.some(item =>
        item.children?.some(child =>
          child.levelArray?.some(levelItem =>
            levelItem.modelSelect === true
          )
        )
      );
    },
    tyEvent () {
      const arr = this.getSelectedAutoids(this.appraisersList)
      if (arr.length == 0)
      {
        Toast("至少选择一项数据")
      } else
      {
        // console.log(arr,'jlklewflhj')
        agreeUser360Pjr({
          autoid: this.appraisersList[0].autoid,
          username: this.userInfo.username,
          pjidlist: arr.join(","),
        }).then(res => {
          if (res.iserror == '0')
          {
            Toast({
              message: this.$t('jxAppraiserReview.revTxt9'),
              position: 'top'
            })
            this.onLoadAwait()
            // 如果revTxt13有设置就询问，没有就直接去360评价
            if (this.sure_jump_caption)
            {
              Dialog.confirm({
                title: this.$t('module.systemhint'),
                message: this.sure_jump_caption,
                confirmButtonText: this.$t('module.confirm'),
                cancelButtonText: this.$t('module.cancel')
              }).then(() => {
                //360待评价记录
                this.$router.push('/jxWhenMyAssesList')
              }).catch(() => { })
            } else
            {
              //360待评价记录
              this.$router.push('/jxWhenMyAssesList')
            }
            done()
          }
        })
      }
    },
    btyEvent () {
      this.showDisagree = true

    },
    onLoadAwait () {
      // 异步更新数据
      // 加载状态开始
      if (this.isLoadingAwait)
      {
        this.appraisersList = []
        this.isLoadingAwait = false
      }
      // this.loadingAwait = true;
      getUser360PjrList({ empid: this.userInfo.empid }).then(res => {
        let baseinfo = res.baseinfo ? res.baseinfo[0] : null || null
        if (baseinfo)
        {
          this.use_dynamic_pjr = baseinfo.use_dynamic_pjr
          this.sure_jump_caption = baseinfo.sure_jump_caption
          this.sure_post_caption = baseinfo.sure_post_caption
          this.sure_type = baseinfo.sure_type
          this.jump_btn_caption = baseinfo.jump_btn_caption
        }
        let arr = []
        if (this.use_dynamic_pjr)
        {
          let arry = res.data
          let afterData = [];
          let tempArr = [];
          // 遍历分组
          for (let i = 0; i < arry.length; i++)
          {
            arry[i].agree = null // 是否同意
            arry[i].modelSelect = false;
            if (!arry[i].picurl)
            {
              arry[i].picurl = ''
            }
            if (tempArr.indexOf(arry[i].checkflagname) == -1)
            {
              let arrs = [];
              arrs.push(JSON.parse(JSON.stringify(arry[i])));
              afterData.push({
                pjper: arry[i].sjper || '',
                levelName: arry[i].checkflagname,
                levelArray: arrs
              });
              tempArr.push(arry[i].checkflagname);
            } else
            {
              for (let j = 0; j < afterData.length; j++)
              {
                if (afterData[j].levelName == arry[i].checkflagname)
                {
                  afterData[j].levelArray.push(
                    JSON.parse(JSON.stringify(arry[i]))
                  );
                  break;
                }
              }
            }
          }
          let obj = baseinfo
          obj.children = afterData
          arr.push(obj)
        } else
        {
          let khplanid = 0
          res.data.forEach((e, index) => {
            let children = []
            let levelArray1 = []
            let levelArray2 = []
            let levelArray3 = []
            if (e.khplanid != khplanid)
            {
              for (let i = 1; i <= 20; i++)
              {
                if (e['sjempid' + i])
                  levelArray1.push({
                    agree: null, // 是否同意
                    empid: e['sjempid' + i],
                    empname: e['sjempname' + i],
                    deptname: e['sjdeptname' + i],
                    empcode: e['sjempcode' + i],
                    picurl:
                      this.userInfo.cappicurl + 'Cap_' + e['sjempid' + i] + '.jpg'
                    // picurl: '/img/interview_pic1.e86dad2c.png'
                  })
                if (e['tjempid' + i])
                  levelArray2.push({
                    agree: null, // 是否同意
                    empid: e['tjempid' + i],
                    empname: e['tjempname' + i],
                    deptname: e['tjdeptname' + i],
                    empcode: e['tjempcode' + i],
                    picurl:
                      this.userInfo.cappicurl + 'Cap_' + e['tjempid' + i] + '.jpg'
                  })
                if (e['xjempid' + i])
                  levelArray3.push({
                    agree: null, // 是否同意
                    empid: e['xjempid' + i],
                    empname: e['xjempname' + i],
                    deptname: e['xjdeptname' + i],
                    empcode: e['xjempcode' + i],
                    picurl:
                      this.userInfo.cappicurl + 'Cap_' + e['xjempid' + i] + '.jpg'
                  })
              }

              children.push({
                pjper: e.sjper,
                levelName: this.$t('jxAppraiserReview.revTxt6'),
                levelArray: levelArray1
              })
              children.push({
                pjper: e.tjper,
                levelName: this.$t('jxAppraiserReview.revTxt7'),
                levelArray: levelArray2
              })
              children.push({
                pjper: e.xjper,
                levelName: this.$t('jxAppraiserReview.revTxt8'),
                levelArray: levelArray3
              })
              khplanid = e.khplanid
              arr.push({
                autoid: e.autoid,
                isagreekpjr: e.isagreekpjr,
                notagreereason: e.notagreereason,
                khplanid: e.khplanid,
                khplanname: e.khplanname,
                children: children
              })
            }
            // console.log(khplanid)
            // e.picurl = this.userInfo.cappicurl + 'Cap_' + e.empid + '.jpg'
            // arr[arr.length - 1].children.push(e)
          })
        }
        this.appraisersList = arr
        console.log(this.appraisersList, 'this.appraisersList')

        // 获取图片
        this.appraisersList.forEach(e => {
          e.children.forEach(item => {
            item.levelArray.forEach(it => {
              // 判断图片是否存在，不存在则替换为默认图片
              checkPic(it, 'picurl')
            })
          })
        })
        // 加载状态结束
        this.loadingAwait = false
        this.finishedAwait = true
        Toast(this.$t('module.refreshSuccessfully'))
        // this.isLoadingAwait = false;
      })
    },
    // 下拉刷新
    onRefreshAwait () {
      this.finishedAwait = false
      this.loadingAwait = true
      this.onLoadAwait()
    },
    // 同意弹窗回调函数
    beforeClose (action, done) {
      if (action === 'confirm')
      {
        agreeUser360Pjr({
          autoid: this.programAutoid,
          username: this.userInfo.username
        }).then(res => {
          if (res.iserror == '0')
          {
            Toast({
              message: this.$t('jxAppraiserReview.revTxt9'),
              position: 'top'
            })
            this.onLoadAwait()
            done()
          }
        })
      } else
      {
        done()
      }
    },
    // 同意按钮
    agreeEntry (autoid) {
      this.programAutoid = autoid
      Dialog.confirm({
        title: this.$t('jxAppraiserReview.revTxt3'),
        message: this.$t('jxAppraiserReview.revTxt10'),
        beforeClose: this.beforeClose
      })
    },
    // 不同意按钮
    disagreeEntry (autoid) {
      this.showDisagree = true
      this.programAutoid = autoid
    },
    // 不同意弹窗确认按钮
    confirm () {
      if (this.disagreeReason)
      {
        const arr = this.getSelectedAutoids(this.appraisersList)
        if (arr.length == 0)
        {
          Toast("至少选择一项数据")
        } else
        {
          notAgreeUser360Pjr({
            autoid: this.appraisersList[0].autoid,
            username: this.userInfo.username,
            notagreereason: this.disagreeReason,
            pjidlist: arr.join(","),
          }).then(res => {
            if (res.iserror == '0')
            {
              Toast({
                message: this.$t('jxAppraiserReview.revTxt9'),
                position: 'top'
              })
              this.onLoadAwait()
              done()
            }
          })
        }
      } else
      {
        Toast({
          message: this.$t('jxAppraiserReview.revTxt12'),
          position: 'top'
        })
      }
    },
    // 关闭不同意弹窗
    closeDia () {
      // 这是每次关闭弹窗后清空参数
      // this.programAutoid = 0
      this.disagreeReason = ''
    }
  }
}
</script>

<style lang="less" scoped>
.jxAppraiserReview {
  height: 100vh;
  overflow: hidden;
  background: #eceaea;

  .van-nav-bar {
    background: #2b8df0;

    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }

    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }

    ::v-deep .van-nav-bar__right {
      .van-nav-bar__text {
        color: #fff;
        font-family: Source Han Sans CN;
      }
    }
  }

  .overflow_div {
    overflow: auto;
    height: calc(100% - 92px);

    // background: #fff;
    /deep/ .program_collapse {
      .program_collapse_item:first-child {
        margin-top: 20px;
      }

      .program_collapse_item {
        margin-bottom: 20px;

        .van-collapse-item__title {
          background: #2b8df0;

          .van-cell__title {
            span {
              height: 44px;
              font-size: 36px;
              font-family: DIN;
              font-weight: bold;
              line-height: 44px;
              color: #ffffff;
            }
          }

          .van-icon {
            color: #ffffff;
          }
        }

        .van-collapse-item__wrapper {
          .van-collapse-item__content {
            background-color: #eceaea;
          }
        }
      }
    }

    /deep/ .children_collapse {
      .van-collapse-item {
        padding-bottom: 20px;

        .van-collapse-item__title {
          background: #ffffff;

          .van-cell__title {
            span {
              height: 44px;
              font-size: 32px;
              font-family: DIN;
              font-weight: bold;
              line-height: 44px;
              color: #000000;
            }
          }

          .van-icon {
            color: #969799;
          }
        }

        .van-collapse-item__wrapper {
          .van-collapse-item__content {
            padding: 0;

            img {
              width: 106px;
              height: 106px;
              margin-right: 30px;
            }

            .van-cell__title {
              span {
                height: 36px;
                font-size: 32px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                line-height: 62px;
                color: #333333;
              }

              .van-cell__label {
                height: 24px;
                font-size: 24px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                line-height: 40px;
                color: #666666;
              }
            }

            .van-cell__value {
              color: #2b8df0;
              span {
                font-size: 32px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                line-height: 62px;
              }
            }

            .batch_submission_cell {
              .van-radio-group {
                justify-content: flex-end;
              }
            }
          }
        }
      }
    }
  }

  .test_button {
    display: flex;
    width: 100%;
    height: 120px;
    padding: 20px;
    box-sizing: border-box;
    background: #fff;

    .wai_div {
      flex: 1;
      text-align: center;

      .van-button {
        height: 100%;
        width: 60%;
      }
    }

    .wai_div:first-child {
      border-right: 1px solid #ccc;
    }
  }

  .entry_button {
    display: flex;
    align-items: center;
    // position: absolute;
    // bottom: 0;
    width: 100%;
    height: 120px;
    padding: 20px;
    box-sizing: border-box;
    background: #fff;

    .disagree {
      color: #f53838;
    }

    span {
      display: inline-block;
      width: 50%;
      height: 100%;
      line-height: 80px;
      box-sizing: border-box;
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #2b8df0;
      text-align: center;
    }

    span:first-child {
      border-right: 1px solid #ccc;
    }
  }

  .van-dialog {
    .van-dialog__header {
      font-size: 36px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      line-height: 62px;
      color: #333333;
    }

    /deep/.van-dialog__content {
      .disagreeReason {
        .van-field__value {
          border: 2px solid #cccccc;
          opacity: 1;
          border-radius: 8px;
        }
      }
    }
  }
}

.divIsZW {
  width: 100%;
  height: 130px;
  background: #fff;
}

.buttonIs_save {
  display: flex;
}

.buttonIsFixed {
  position: fixed;
  bottom: 0;
  z-index: 99;
  left: 0;
  width: 100%;
  background: #fff;
  box-shadow: -1px 1px 1px 0px #ccc;
  padding: 10px 0.42667rem;
}
</style>
